import { action } from 'mobx'
// Request
import { TimekeepingSyncRequest } from '../requests/TimekeepingSyncRequest'

class TimekeepingStore {
  @action exportToExcel = params => {
    return TimekeepingSyncRequest.exportToExcel(params).catch(console.log)
  }
}

export default new TimekeepingStore()
